import { loadScanGiftConf } from '../api';
import { ValidConfigItem } from '../types';
/**
 * 根据条件过滤配置
 * @param campaignId 计划Id
 * @param spId 商户Id
 */
export async function getConfigById(campaignId: string, spId: string): Promise<ValidConfigItem | undefined> {
  const rawScanGiftConf = await loadScanGiftConf();

  const findItem = rawScanGiftConf.find(item => item.campaignId === campaignId && item.spIdList.includes(spId));

  console.log('useScanGift validFixedScanGift', findItem);

  return findItem ? {
    campaignId: findItem.campaignId,
    fixedCouponInfo: findItem.fixedCouponInfo,
    tncUrl: findItem.tncUrl,
    spId,
    skin: findItem.skin,
    title: findItem.title,
    promptDialogPic: findItem.promptDialogPic,
  } : undefined;
}
